import { render, staticRenderFns } from "./PartnerCourse.vue?vue&type=template&id=68e32da0&scoped=true"
import script from "./PartnerCourse.vue?vue&type=script&lang=js"
export * from "./PartnerCourse.vue?vue&type=script&lang=js"
import style0 from "./PartnerCourse.vue?vue&type=style&index=0&id=68e32da0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e32da0",
  null
  
)

export default component.exports